import { action, computed } from 'mobx'
import { type BookkeepingPendingAction } from './BookkeepingPendingAction'
import { type BookkeepingManagerDetailsViewModel } from '@/features/admin/bookkeeping/components/BookkeepingManagerDetails/BookkeepingManagerDetailsViewModel'

/**
 * A row in the bookkeeping manager table.
 */
export class BookkeepingPendingActionItemViewModel {
  constructor(
    readonly bookkeepingPendingAction: BookkeepingPendingAction,
    private readonly _detailsVm: BookkeepingManagerDetailsViewModel,
  ) {}

  /**
   * Whether the details panel shows this pending action.
   */
  @computed
  get isActive() {
    return (
      this._detailsVm.bookkeepingPendingAction.id ===
      this.bookkeepingPendingAction.id
    )
  }

  /**
   * Shows the pending action in the details panel.
   */
  @action.bound
  select() {
    this._detailsVm.show(this.bookkeepingPendingAction)
  }
}
